import Typography from "@mui/material/Typography"

import Row from "./Row"
import PaddedTopSection from "./TopSection"

export default function PageTopSection({ title, children }) {
  return (
    <PaddedTopSection
      sx={{
        borderBottom: "2px solid rgba(255, 255, 255, 0.32)",
        paddingInline: "24px",
        paddingBlock: "20px",
      }}
    >
      <Row sx={{ justifyContent: "space-between" }}>
        <Typography
          variant="h2"
          sx={{
            alignSelf: "center",
            color: "#0f1216",
          }}
        >
          {title}
        </Typography>
        {children}
      </Row>
    </PaddedTopSection>
  )
}
